import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { authData } from "src/app/util/auth";
import { errorHandler } from "src/app/util/errorHandler";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-elective-popup",
  templateUrl: "./elective-popup.component.html",
  styleUrls: ["./elective-popup.component.scss"],
})
export class ElectivePopupComponent implements OnInit {
  @Input() showElectivePopup = false;
  @Output() fetchChecks = new EventEmitter<string>();

  electives: any[] = []; 
  selectedElectives: { [key: string]: string } = {}; 
  _auth = authData(); 
  notification = {}; 
  loading: boolean = false;

  constructor(private httpClient: HttpClient) {}

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this._auth.Token, 
    }),
  };

  ngOnInit(): void {
    this.getElectives(); 
  }

  getElectives() {
    const baseUrl = `${environment.BASE_URL}/users/GetElectives`; 
    this.httpClient.get(baseUrl, this.httpOptions).subscribe({
      next: (res: any) => {
        this.electives = res.Data || []; 
      },
      error: (err) => {
        console.error("Error fetching electives:", err);
      },
    });
  }

  submitElectives() {
    if (Object.keys(this.selectedElectives).length === 0) return; 
    this.loading = true;

    const electivesToSave = Object.entries(this.selectedElectives).map(([key, value]) => ({
      SubjectGroupID: key,
      SubjectID: value
    }));

    const baseUrl = `${environment.BASE_URL}/users/SaveElectives`; 
    this.httpClient.post(baseUrl, electivesToSave, this.httpOptions).subscribe({
      next: (res: any) => {
        if (!res.Success) {
          this.loading = false;
          this.notification = {
            error: true,
            message:
              res?.Message || "An error occurred. Please, try again",
          };
        } else {
          this.handleResponse("Electives saved successfully");
        }
      },
      error: (err) => {
        this.loading = false;
        this.notification = errorHandler(err);
      },
    });
  }

  handleResponse(message: string) {
    // const auth = sessionStorage.getItem("_auth");
    // if (auth !== null) {
    //   const authObj = JSON.parse(auth);
    //   authObj.ShowElectivePopup = false; 
    //   sessionStorage.setItem("_auth", JSON.stringify(authObj));
    // }
    message ? this.fetchChecks.emit(message) : this.fetchChecks.emit();
  }
}
